(function() {
  var commonImages = [34145614299182, 13343680856110, 13343517474862, 13343517605934,
    13343680888878, 13343517638702, 13343517671470, 13343517737006];

  function initialize() {
    var container = document.getElementById('ProductSection-product-template');
    var json = document.getElementById('ProductJson-product-template');
    if (!container || !json) return;
    var product = JSON.parse(json.textContent);
    if (product.handle !== 'maxx-volts-premium-wifi-compatible-model-charging-system') return;
    var input = container.querySelector('select[name="id"]');
    if (!input) return;

    function apply(variant) {
      if (!variant) return;
      var imageId = variant.featured_image ? variant.featured_image.id : commonImages[0];
      var allowed = commonImages.concat([imageId]);
      container.querySelectorAll('.product-single__photo-wrapper').forEach(function(wrapper) {
        var photo = wrapper.querySelector('.product-single__photo');
        var id = Number(photo.dataset.imageId);
        wrapper.style.display = allowed.indexOf(id) !== -1 ? '' : 'none';
        photo.classList.toggle('hide', id !== Number(imageId));
      });
      container.querySelectorAll('.product-single__thumbnails-item').forEach(function(item) {
        var id = Number(item.querySelector('.product-single__thumbnail').dataset.thumbnailId);
        item.style.display = allowed.indexOf(id) !== -1 ? '' : 'none';
      });
      if (window.jQuery) {
        var slider = window.jQuery(container).find('.product-single__thumbnails.slick-initialized');
        if (slider.length) {
          slider.slick('slickUnfilter');
          slider.slick('slickFilter', function() {
            var link = this.querySelector('.product-single__thumbnail');
            return link && allowed.indexOf(Number(link.dataset.thumbnailId)) !== -1;
          });
        }
      }
    }

    function selected() {
      return product.variants.find(function(variant) { return String(variant.id) === input.value; });
    }
    apply(selected());
    input.addEventListener('change', function() { apply(selected()); });
    container.querySelectorAll('.single-option-selector').forEach(function(select) {
      select.addEventListener('change', function() { setTimeout(function() { apply(selected()); }, 0); });
    });
    if (window.jQuery) {
      window.jQuery(container).on('variantChange.maxxWifiGallery', function(event) { apply(event.variant); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
